import { isValid } from "../util"

export default function validatePayload(payload) {
	return Object.entries(payload).reduce((errors, [key, value]) => {
		if (!isValid(value)) errors.push(key)
		return errors
	}, [])
}
